const TiposCosto = [
  { label: "Fijo", value: "Fijo" },
  { label: "Variable", value: "Variable" },
]

export default TiposCosto